import script from "./ApprovalSioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalSioPage.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalSioPage.vue?vue&type=style&index=0&id=8f0b34a0&scoped=true&lang=css"
import "./ApprovalSioPage.vue?vue&type=style&index=1&id=8f0b34a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f0b34a0"]])

export default __exports__